<script>
    let shown = false;
    export function show() {
        shown = true;
    }
    export function hide() {
        shown = false;
    }
</script>

<style>
    .alert-modal-wrapper {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: var(--foreground-alpha-color);
    }

    .alert-modal {
        width: 70%;
        margin: 15% auto;
        padding: 0;
        background-color: var(--background-color);
    }

    .header,
    :global(.footer) {
        display: flex;
        align-items: center;
        justify-content: flex-end;

        width: 100%;
        padding: 0.5%;
    }

    :global(.footer) {
        justify-content: space-between;

        width: 60%;
        margin: 0 auto 2.5% auto;
        padding: 0.5% 0.5% 4% 0.5%;
    }

    :global(.footer button) {
        display: block;
        width: 40%;
        font-size: 20px;
        color: var(--background-color);

        margin: 0;
        padding: 1%;

        border-radius: 5px;
        outline: 0;
        border: 0;
        cursor: pointer;
    }

    :global(.footer button):nth-child(1) {
        background-color: var(--orange-color);
    }

    :global(.footer button):nth-child(2) {
        background-color: var(--green-color);
    }

    :global(.footer button):hover,
    :global(.footer button):focus {
        background-color: var(--blue-color);
    }

    .close {
        width: 25px;
        height: 25px;

        margin: 0;

        font-size: 18px;
        color: var(--main-text-color);

        border-radius: 50%;
        border: 0;
        outline: 0;
        background-color: var(--background-color);
        cursor: pointer;
    }

    .close:hover {
        border: 1px solid var(--orange-color);
        color: var(--orange-color);
    }

    :global(.title),
    :global(.description) {
        display: block;
        width: 100%;

        margin: 0;
        padding: 0;

        font-size: 20px;
        font-weight: normal;
        text-align: center;
        letter-spacing: 1px;
        text-transform: uppercase;
        color: var(--foreground-color);
    }

    :global(.description) {
        margin: 5% 0;
        font-size: 18px;
        letter-spacing: normal;
        text-transform: none;
    }

    @media (min-width: 1024px) {
        .alert-modal {
            width: 40%;
            margin: 5% auto;
        }
    }
</style>

{#if shown}
    <div class="alert-modal-wrapper">
        <div class="alert-modal">
            <div class="header">
                <button class="fas fa-times close" on:click={() => hide()} />
            </div>
            <slot />
        </div>
    </div>
{/if}
